import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { EditRouteService } from '../../services';
import { TranslateModule } from '@ngx-translate/core';
import { BreakpointsService } from 'src/app/services';

@Component({
  selector: 'app-edit-route-register',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './edit-route-register.component.html',
  styleUrls: ['./edit-route-register.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditRouteRegisterComponent {  
  private _editRouteService = inject(EditRouteService);
  private _breakpointsService = inject(BreakpointsService);
  
  protected customEditedRouteResponse = this._editRouteService.customEditedRouteResponse;
  protected isEditRouteRegisterOpen = this._editRouteService.isEditRouteRegisterOpen;
  private _isMobile = this._breakpointsService.isMobile;
  
  protected handleBackToEditRouteClick(): void {
    this._editRouteService.setIsEditRouteRegisterOpen(false);
    this._editRouteService.setCustomEditedRouteResponse(null);
  }
  
  protected checkIsSuccessList(): boolean {
    return this._editRouteService.checkIsSuccessListCustomEditedRouteResponse();
  }

  protected checkIsErrorList(): boolean {
    return this._editRouteService.checkIsErrorListCustomEditedRouteResponse();
  }

  protected checkIsOnlyErrorList(): boolean {
    return this._editRouteService.checkIsOnlyErrorListCustomEditedRouteResponse();
  }
  
  protected getHeightScrollFade(): string {
    if (this.checkIsOnlyErrorList()) {
      return this._isMobile() ? '400px' : '800px';
    }
    return  this._isMobile() ? '160px' : '400px';
  }
}